import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NavigationItem from './NavigationItem';
import NavigationTab from './NavigationTab';
import routes from '../../../routes';
import { checkPermissions } from '../../../services/helpers';

const Navigation = ({ onToggle }) => {
  const adminPermissions = useSelector(state => state.auth.admin.permissions);

  const adminPermissionsNames = adminPermissions?.map(perm => perm?.name);

  const isMarketShow = checkPermissions(
    [
      'manage assets pairs',
      'add tokens',
      'set limits',
      'set fees',
      'manage currencies',
      'manage market maker',
    ],
    adminPermissionsNames,
  );

  const isSuperAdmin =
    adminPermissionsNames.includes('view orders') &&
    adminPermissionsNames.includes('manage assets pairs') &&
    adminPermissionsNames.includes('add tokens') &&
    adminPermissionsNames.includes('set limits') &&
    adminPermissionsNames.includes('set fees') &&
    adminPermissionsNames.includes('manage currencies') &&
    adminPermissionsNames.includes('view profits') &&
    adminPermissionsNames.includes('manage wallets') &&
    adminPermissionsNames.includes('view referrals') &&
    adminPermissionsNames.includes('manage bank accounts') &&
    adminPermissionsNames.includes('manage admins') &&
    adminPermissionsNames.includes('manage users') &&
    adminPermissionsNames.includes('manage crypto bank transfers') &&
    adminPermissionsNames.includes('manage fiat bank transfers') &&
    adminPermissionsNames.includes('manage market maker') &&
    adminPermissionsNames.includes('manage blog') &&
    adminPermissionsNames.includes('manage general');

  // 0: "view orders"  +
  // 1: "manage assets pairs"  +
  // 2: "add tokens"  +
  // 3: "set limits"  +
  // 4: "set fees"  +
  // 5: "manage currencies"  +
  // 8: "view profits"  +
  // 9: "manage wallets"  +
  // 10: "view referrals"  +
  // 11: "change password"  +
  // 12: "manage admins"  +
  // 14: "manage users"  +
  // 15: "manage crypto bank transfers"  +
  // 16: "manage fiat bank transfers"  +
  // 17: "manage market maker"  +

  return (
    <div className="dash-sidebar dash-sidebar--admin">
      <div className="logo-wrap">
        <Link to={`${routes.Users.path}`} className="dash-logo">
          <img src="/img/logo.svg" alt="" />
        </Link>
        <button className="xs-dash-nav-btn" type="button">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.7999 6.80003L13.1999 6.80002M13.1999 6.80002V1.20003M13.1999 6.80002L19.5999 0.400024M6.7999 18.8L6.7999 13.2M6.7999 13.2L1.1999 13.2M6.7999 13.2L0.399902 19.6"
              stroke="#424242"
            />
          </svg>
        </button>
      </div>

      <button onClick={onToggle} className="dash-nav-btn" type="button">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.7999 6.80003L13.1999 6.80002M13.1999 6.80002V1.20003M13.1999 6.80002L19.5999 0.400024M6.7999 18.8L6.7999 13.2M6.7999 13.2L1.1999 13.2M6.7999 13.2L0.399902 19.6"
            stroke="#424242"
          />
        </svg>
      </button>

      <div className="dash-xs-nav">
        <nav className="dash-nav dash-nav--admin">
          <ul className="dash-nav__list">
            {adminPermissionsNames.includes('manage users') && (
              <NavigationTab
                title="Users"
                icon="fa fa-user"
                link={routes.Users.path}
              >
                <NavigationItem
                  link={routes.Users.path}
                  name="Users List"
                  icon="fa fa-user"
                />
                <NavigationItem
                  link={routes.Reset2FA.path}
                  name="Reset 2FA"
                  icon="fa fa-shield-alt"
                />
                <NavigationItem
                  link={routes.ChatAdminUsers.path}
                  name="Chat Admin Users"
                  icon="fas fa-comments"
                />
                {adminPermissionsNames.includes('view referrals') && (
                  <NavigationItem
                    link={routes.ReferralSystem.path}
                    name="Referral System"
                    icon="fa fa-table"
                  />
                )}

                {adminPermissionsNames.includes('set fees') && (
                  <>
                    <NavigationItem
                      link={routes.Cashbacks.CashbackList.path}
                      name="Cashback"
                      icon="fas fa-money-bill-wave"
                    />
                    <NavigationItem
                      link={routes.Cashbacks.Statistics.path}
                      name="Cashback Statistics"
                      icon="fas fa-signal"
                    />
                  </>
                )}

                {isSuperAdmin && (
                  <NavigationItem
                    link={routes.HistoryReplenishment.path}
                    name="History Replenishment"
                    icon="fa fa-credit-card"
                  />
                )}
              </NavigationTab>
            )}

            {/* {adminPermissionsNames.includes('manage users') && (
              <NavigationItem
                link={routes.Users.path}
                name="Users"
                icon="fa fa-user"
              />
            )}

            {adminPermissionsNames.includes('manage users') && (
              <NavigationItem
                link={routes.Reset2FA.path}
                name="Reset 2FA"
                icon="fa fa-shield-alt"
              />
            )} */}
            {adminPermissionsNames.includes('view orders') && (
              <NavigationItem
                link={routes.Orders.path}
                name="Orders"
                icon="fa fa-file"
              />
            )}

            {adminPermissionsNames.includes('set fees') && (
              <NavigationItem
                link={routes.Trades.path}
                name="Trades"
                icon="fa fa-file"
              />
            )}

            {/* {adminPermissionsNames.includes('set fees') && (
              <NavigationTab
                title="Cashback"
                icon="fa fa-file"
                link={routes.Cashbacks.CashbackList.path}
              >
                <NavigationItem
                  link={routes.Cashbacks.CashbackList.path}
                  name="Cashback"
                  icon="fas fa-money-bill-wave"
                />
                <NavigationItem
                  link={routes.Cashbacks.Statistics.path}
                  name="Statistics"
                  icon="fas fa-signal"
                />
              </NavigationTab>
            )} */}

            {isMarketShow && (
              <NavigationTab
                title="Market"
                icon="fa fa-file"
                link={routes.Market.TradingPairs.path}
              >
                {adminPermissionsNames.includes('manage assets pairs') && (
                  <NavigationItem
                    link={routes.Market.TradingPairs.path}
                    name="Trading Pairs"
                    icon="fa fa-compass"
                  />
                )}

                {adminPermissionsNames.includes('set fees') && (
                  <NavigationItem
                    link={routes.Market.FeesAndLimits.path}
                    name="Trade Fees And Limits"
                    icon="fas fa-percent"
                  />
                )}

                {adminPermissionsNames.includes('set fees') && (
                  <NavigationItem
                    link={routes.Market.TradeVolumeSettings.path}
                    name="Trade Volume Settings"
                    icon="far fa-compass"
                  />
                )}

                {adminPermissionsNames.includes('add tokens') && (
                  <NavigationItem
                    link={routes.Market.Tokens.path}
                    name="Tokens"
                    icon="fab fa-btc"
                  />
                )}

                {adminPermissionsNames.includes('set limits') && (
                  <NavigationItem
                    link={routes.Market.Limitations.path}
                    name="Limitations"
                    icon="fa fa-bolt"
                  />
                )}

                {adminPermissionsNames.includes('set fees') && (
                  <NavigationItem
                    link={routes.Market.Fees.path}
                    name="Platform Fees"
                    icon="fa fa-percent"
                  />
                )}

                {adminPermissionsNames.includes('manage currencies') && (
                  <NavigationItem
                    link={routes.Market.Currencies.path}
                    name="Currencies"
                    icon="fa fa-coins"
                  />
                )}

                {adminPermissionsNames.includes('manage market maker') && (
                  <NavigationItem
                    link={routes.Market.Robot.path}
                    name="Market-Maker Robot"
                    icon="fa fa-file"
                  />
                )}
              </NavigationTab>
            )}

            {adminPermissionsNames.includes('manage fiat bank transfers') && (
              <NavigationTab
                title="Fiat Transfer"
                icon="fa fa-credit-card"
                link={routes.FiatTransfer.Deposit.path}
              >
                <NavigationItem
                  link={routes.FiatTransfer.Deposit.path}
                  name="Transaction Deposit"
                  icon="fa fa-credit-card"
                />
                <NavigationItem
                  link={routes.FiatTransfer.Pending.path}
                  name="Pending Withdrawals"
                  icon="fa fa-database"
                />
                <NavigationItem
                  link={routes.FiatTransfer.Withdrawals.path}
                  name="Transaction Withdrawals"
                  icon="fa fa-database"
                />
              </NavigationTab>
            )}

            {adminPermissionsNames.includes('manage crypto bank transfers') && (
              <NavigationTab
                title="Crypto Transfer"
                icon="fa fa-credit-card"
                link={routes.CryptoTransfer.Deposit.path}
              >
                <NavigationItem
                  link={routes.CryptoTransfer.Deposit.path}
                  name="Transaction Deposit"
                  icon="fa fa-credit-card"
                />
                <NavigationItem
                  link={routes.CryptoTransfer.Pending.path}
                  name="Pending Withdrawals"
                  icon="fa fa-database"
                />
                <NavigationItem
                  link={routes.CryptoTransfer.Withdrawals.path}
                  name="Transaction Withdrawals"
                  icon="fa fa-database"
                />
              </NavigationTab>
            )}

            {adminPermissionsNames.includes('manage wallets') && (
              <NavigationTab
                title="Wallets"
                icon="fa fa-wallet"
                link={routes.Wallets.Wallets.path}
              >
                <NavigationItem
                  link={routes.Wallets.Wallets.path}
                  name="Wallets"
                  icon="fa fa-th"
                />

                <NavigationItem
                  link={routes.Wallets.Transactions.path}
                  name="Transactions"
                  icon="fa fa-credit-card"
                />

                {adminPermissionsNames.includes('view profits') && (
                  <NavigationItem
                    link={routes.Wallets.Profits.path}
                    name="Profits"
                    icon="fa fa-percent"
                  />
                )}

                <NavigationItem
                  link={routes.Wallets.Bnixfee.path}
                  name="Doz fee"
                  icon="fa fa-percent"
                />

                <NavigationItem
                  link={routes.Wallets.GasFeeSettings.path}
                  name="Gas Fee Settings"
                  icon="fa fa-cog"
                />
              </NavigationTab>
            )}

            <NavigationTab
              title="Vote"
              icon="far fa-thumbs-up"
              link={routes.Vote.path}
            >
              <NavigationItem
                link={routes.Vote.path}
                name="Projects"
                icon="fas fa-project-diagram"
              />
              <NavigationItem
                link={routes.Vote.VoteProjectBalance.path}
                name="Projects balance"
                icon="fas fa-money-check-alt"
              />
              <NavigationItem
                link={routes.FutureVote.path}
                name="Future Projects"
                icon="fas fa-project-diagram"
              />
            </NavigationTab>

            <NavigationTab
              title="IEO/Listing"
              icon="fas fa-th-list"
              link={routes.IEOListing.path}
            >
              <NavigationItem
                link={routes.IEOListing.path}
                name="Projects"
                icon="fas fa-project-diagram"
              />
               <NavigationItem
                link={routes.IEOListing.NewProject.path}
                name="NewIEOProjects"
                icon="fas fa-project-diagram"
              />
            </NavigationTab>

            {/* {adminPermissionsNames.includes('view referrals') && (
              <NavigationItem
                link={routes.ReferralSystem.path}
                name="Referral System"
                icon="fa fa-table"
              />
            )} */}

            {adminPermissionsNames.includes('manage admins') && (
              <NavigationItem
                link={routes.Administration.path}
                name="Administration"
                icon="fa fa-eye"
              />
            )}

            <NavigationTab
              title="General"
              icon="fas fa-globe"
              link={routes.Videos.path}
            >
              {adminPermissionsNames.includes('manage general') && (
                <NavigationItem
                  link={routes.Videos.path}
                  name="Videos"
                  icon="fas fa-video"
                />
              )}

              {adminPermissionsNames.includes('manage general') && (
                <NavigationItem
                  link={routes.Vacancies.path}
                  name="Vacancies"
                  icon="fas fa-briefcase"
                />
              )}

              {adminPermissionsNames.includes('manage general') && (
                <NavigationItem
                  link={routes.TraderInfo.path}
                  name="Trader Info"
                  icon="fas fa-info-circle"
                />
              )}

              {adminPermissionsNames.includes('manage blog') && (
                <NavigationItem
                  link={routes.Posts.path}
                  name="Blog"
                  icon="fas fa-blog"
                />
              )}
            </NavigationTab>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navigation;
